<template>
  <div class="container py-5 selling-points">
    <div class="row">
      <section class="col-12 p-0">
        <div id="map" style="height: 650px;"></div>
      </section>
    </div>
    <div class="row my-5">
      <div class="col-12 d-none d-md-flex search-region-group-col">
        <div class="input-group mb-3">
          <input type="text"
                 class="form-control text-lg p-4 search-region-input-text"
                 placeholder="Πόλη"
                 aria-label="Πόλη"
                 v-model="searchInput"
                 @change="searchSellingPoints(searchInput)"
          />
          <div class="input-group-append">
            <button class="btn search-region-input-button"
                    type="button"
                    @click="searchSellingPoints(searchInput)"
            >ΒΡΕΙΤΕ ΤΟ ΚΟΝΤΙΝΟΤΕΡΟ ΦΑΡΜΑΚΕΙΟ</button>
          </div>
        </div>
      </div>
      <div class="col-12 d-block d-md-none">
        <div class="col-12">
          <input type="text"
                 class="form-control text-lg p-4 search-region-input-text-mob w-100"
                 placeholder="Πόλη"
                 aria-label="Πόλη"
                 v-model="searchInput"
                 @change="searchSellingPoints(searchInput)"
          />
        </div>
        <div class="col-12">
          <button class="btn search-region-input-button-mob w-100"
                  type="button"
                  @click="searchSellingPoints(searchInput)"
          >ΒΡΕΙΤΕ ΤΟ ΚΟΝΤΙΝΟΤΕΡΟ ΦΑΡΜΑΚΕΙΟ</button>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 col-lg-4 d-flex align-items-stretch" v-for="sellingPoint in cachedfilteredSearchedClosestSellingPoints">
        <div class="card bg-transparent border-0 w-100">
          <div class="card-body bg-transparent border-0">
            <ul class="list-group list-group-flush">
              <li class="list-group-item bg-transparent border-0 selling-point-entry-distance">Απέχει {{ formatDistance(getDistanceInMeters(sellingPoint)) }}</li>
              <li class="list-group-item bg-transparent border-0"><h6 class="text-dark">{{sellingPoint.name}}</h6></li>
              <li class="list-group-item bg-transparent border-0">{{sellingPoint.address}}</li>
              <li class="list-group-item bg-transparent border-0">{{sellingPoint.region}}</li>
              <li class="list-group-item bg-transparent border-0">{{sellingPoint.postal}} {{sellingPoint.country}}</li>
              <li class="list-group-item bg-transparent border-0">{{sellingPoint.phone}}</li>
              <li class="list-group-item bg-transparent border-0 selling-point-entry-maplink"><a
                :href="`https://www.google.com/maps/search/${sellingPoint.latitude},${sellingPoint.longitude}`"
                target="_blank"
              >Δείτε το στον χάρτη</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMapsService from '../../../vue/services/googleMapsService'
import _ from 'lodash'

export default {
  name: 'LaboSellingPoints',
  computed: {
    filteredSearchInput: function () {
      return _.trim(_.toLower(this.searchInput))
    },
    filteredSearchedSellingPoints: function () {
      return _.filter(_.cloneDeep(this.sellingPoints), function (sellingPoint) {
        const searchable = this.getSellingPointSearchable(sellingPoint)
        return _.includes(searchable, this.filteredSearchInput)
      }.bind(this))
    },
    filteredSearchedClosestSellingPoints: function () {
      const closestPoints = _.map(this.closestSellingPoints, closestSellingPoint => closestSellingPoint.sellingPoint)
      return _.take(closestPoints, this.maxResults)
    }
  },
  data () {
    return {
      searchInput: '',
      maxResults: 18,
      sellingPoints: window.selling_points,
      closestSellingPoints: {},
      cachedfilteredSearchedClosestSellingPoints: {}
    }
  },
  methods: {
    searchSellingPoints: function (searchKey) {
      if (_.isEmpty(this.filteredSearchInput)) { return }
      GoogleMapsService.findClosest(this.filteredSearchInput, this.sellingPoints)
    },
    getSellingPointSearchable: function (sellingPoint) {
      const searchable = `${sellingPoint.name} ${sellingPoint.address} ${sellingPoint.phone} ${sellingPoint.postal} ${sellingPoint.region} ${sellingPoint.country}`
      return _.toLower(searchable)
    },
    getSellingPointById: function (sellingPointId) {
      return _.find(this.sellingPoints, (sellingPoint) => sellingPoint.id * 1 === sellingPointId)
    },
    getSellingPointById2: function (sellingPointId) {
      return _.find(this.filteredSearchedSellingPoints, (sellingPoint) => sellingPoint.id * 1 === sellingPointId)
    },
    findSellingPointByName: function (inputName) {
      return _.find(this.sellingPoints, (sellingPoint) => _.includes(sellingPoint.name, inputName))
    },
    getDistanceInMeters: function (sellingPoint) {
      return _.find(this.closestSellingPoints, (closestSellingPoint) =>
        closestSellingPoint.sellingPoint === sellingPoint).distance
    },
    formatDistance: function (distance) {
      if (distance > 1000) {
        var distanceInKm = distance / 1000
        return distanceInKm.toFixed(2) + 'km'
      }
      return Math.round(distance) + 'm'
    }
  },
  mounted: function () {
    GoogleMapsService.createMap([])
    this.$root.$on('findClosest', function (closestSellingPoints) {
      this.closestSellingPoints = closestSellingPoints
      GoogleMapsService.updateMap(this.filteredSearchedClosestSellingPoints)
      this.cachedfilteredSearchedClosestSellingPoints = this.filteredSearchedClosestSellingPoints
    }.bind(this))
  }
}
</script>
